import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (
    location.pathname.startsWith("/mentor/dashboard/review/learner/") &&
    !location.pathname.endsWith("/topic-review")
  ) {
    localStorage.setItem("learnerPath", location.pathname);
  }

  return token ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
